import { Col, EventHandler, Label, PopupDialogbox, PrimaryButton, ReactSelectBox, Row, SofturaTable, SwitchToggle, Tabs } from "client/CommonComponents"
import excel from '../../../../assets/images/Excel.svg'
import permissions, { isAuthorized } from "client/utils/Permissions"
import "./ApprovalListAssignment.scss"
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup"
import AdditionalApprovers from "./AdditionalApprovers"
import ListAssignment from "./ListAssignment"

const ApprovalListAssignment = (props: any) => {
    const {
        regionDropDownList,
        selectedRegion,
        marketDropDownList,
        selectedMarket,
        handleChange,
        costCenterDropdownList,
        selectedCostCenter,
        approvalAssignement,
        additionalApprovalListGridData,
        approvalListAssignmentColumns,
        additionalApproversColumns,
        isEditList,
        handleChangeEditList,
        showGrid,
        onSaveClick,
        showAlert,
        Popupcontent,
        hideDialog,
        getAlertMessage,
        onExportExcel,
        onAllExportExcel,
        costCentersBySearchList,
        handleChangeSearchedCostCenter,
        searchCostCenter,
        selectedSearchedCostCenter,
        onClearClick,
        showValidatePopup,
        handleLinkClick,
        selectedKey
    } = props

    const tabItems = [
        {
            itemKey: "approvalListAssignment",
            headerText: "Approval List Assignment",
            content: <ListAssignment approvalAssignement={approvalAssignement} approvalListAssignmentColumns={approvalListAssignmentColumns} showGrid={showGrid} />
        },
        {
            itemKey: "additionalApprovers",
            headerText: "Additional Approvers",
            content: <AdditionalApprovers additionalApprovalListGridData={additionalApprovalListGridData} additionalApproversColumns={additionalApproversColumns} showGrid={showGrid} />
        }
    ];

    return (
        <>
            <div className="row">
                <div className='penalityHeader margin-bottom-heading'>
                    <p className='headingText pull-left'>Approval List Assignment</p>
                </div>
            </div>
            <Row className="mb-2">
                    <Col xs={12} sm={12} md={6} lg={3} className="mb-3 mb-lg-0 mb-md-0 mb-sm-0">
                        <Label data-attribute="ApprovalListAssignment_Default_Label">Region</Label>
                        <ReactSelectBox
                            name='region'
                            placeholder='Select Region'
                            options={regionDropDownList}
                            value={selectedRegion ?? ''}
                            isSearchable={true}
                            onChange={(value: any) => handleChange(value, 'region')}  data-attribute="ApprovalListAssignment_region_SearchSelectBox" />
                    </Col>
                {selectedRegion && marketDropDownList?.length ?
                    <Col xs={12} sm={12} md={6} lg={3} className= {`mb-3 mb-lg-0 mb-md-0 mb-sm-0 ${(selectedRegion && !selectedMarket) ? "marketnotselected" : null}`}>
                        <Label data-attribute="ApprovalListAssignment_Default_Label_2">Market</Label>
                        <ReactSelectBox
                            name='market'
                            placeholder='Select Market'
                            options={marketDropDownList}
                            value={selectedMarket ?? ''}
                            isSearchable={true}
                            onChange={(value: any) => handleChange(value, 'market')}  data-attribute="ApprovalListAssignment_market_SearchSelectBox" />
                    </Col>
                    : null}
                { selectedRegion && selectedMarket && costCenterDropdownList?.length ?
                    <Col xs={12} sm={12} md={6} lg={3} className="mb-1 mb-lg-0 mb-md-0 mb-sm-0 mt-md-2 mt-lg-0 ">
                        <Label data-attribute="ApprovalListAssignment_Default_Label_3">Cost Center</Label>
                        <ReactSelectBox
                            name='costCenter'
                            placeholder='Select Cost Center'
                            options={costCenterDropdownList}
                            onChange={(value: any) => handleChange(value, 'costCenter')}
                            value={selectedCostCenter}
                            isSearchable={true}
                            className='mb-3'
                         data-attribute="ApprovalListAssignment_costCenter_SearchSelectBox" />
                    </Col> : null}

                    {(selectedRegion || selectedSearchedCostCenter) ?
                        <Col xs={12} sm={12} md={6} lg={3} className='clearfilter_approvalistscr mt-md-2 mt-lg-0'>
                            <div className="pull-right">
                            <PrimaryButton
                                text="Clear Filters"
                                className="pull-right"
                                onClick={onClearClick}
                             data-attribute="ApprovalListAssignment_Default_Button" />
                            </div>
                        </Col>
                    : null}  
            </Row>
             
            <Row className="mb-3">
                <Col xs={12} sm={12} md={6} lg={3} className="mb-2">
                    <div>
                        <Label data-attribute="ApprovalListAssignment_Default_Label_4">Search for Cost Center</Label>
                        <ReactSelectBox
                            name='searchedCostCenter'
                            placeholder='Search Cost Center'
                            options={costCentersBySearchList}
                            onChange={(value: any) => handleChangeSearchedCostCenter(value, 'searchedCostCenter')}
                            onInputChange={searchCostCenter}
                            value={selectedSearchedCostCenter}
                            isSearchable={true}
                            className='mb-3'
                         data-attribute="ApprovalListAssignment_searchedCostCenter_SearchSelectBox" />
                    </div>
                </Col>
                <Col xs={12} sm={12} md={6} lg={9} className="mb-2">
                    <div className='mb-1 top-section approval-hierarchy'>
                        <div className='clearfix'>
                            <div className='btn-block-approvalhierarchy pull-right pt-3'>
                                {showGrid &&
                                    <>
                                        <div className="toggleContainer">
                                            <SwitchToggle
                                                className="mt-2"
                                                checked={isEditList}
                                                onChange={(e: any, value: any) => handleChangeEditList(e, value)}
                                                disabled={!isAuthorized(permissions?.CreateEditHierarchy) || !approvalAssignement?.length}
                                             data-attribute="ApprovalListAssignment_Default_SwitchToggle" />
                                            <span className="st-text">Edit Approvers</span>
                                        </div>
                                        <div className="excelContainer">
                                            <span className="exportLabel">Export Current</span>
                                            <div className={`excel-section-approvalhierarchy mt-1 ${approvalAssignement?.length ? "" : "disable-export-excel"}`}>
                                                <EventHandler onEvent={onExportExcel} data-attribute="ApprovalListAssignment_Default_EventHandler">
                                                    <img
                                                        src={excel}
                                                        alt='excel'
                                                        className={`${approvalAssignement?.length ? "" : "disable-approval-list-excel"}`}
                                                    />
                                                </EventHandler>
                                            </div>
                                        </div>
                                    </>
                                }
                               <div className="excelContainer">
                               <span className="exportLabel">Export All</span>
                                <div className={`excel-section-approvalhierarchy mt-1`}>
                                    <EventHandler onEvent={onAllExportExcel} data-attribute="ApprovalListAssignment_Default_EventHandler_2">
                                        <img
                                            src={excel}
                                            alt='excel'
                                        />
                                    </EventHandler>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                {(selectedRegion || selectedMarket || selectedSearchedCostCenter) && <Tabs
                    tabItems={tabItems}
                    className='approval-dashboard-tab'
                    selectedKey={selectedKey}
                    handleLinkClick={handleLinkClick}
                 data-attribute="ApprovalListAssignment_Default_Tabs" />}
                {/* <div className={`pe-0 ${approvalAssignement?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                    {(showGrid && (selectedRegion || selectedMarket || selectedSearchedCostCenter))?
                        <SofturaTable
                            data={approvalAssignement ?? []}
                            columns={approvalListAssignmentColumns}
                            sort={false}
                            pagination={false}
                            globalSearch={false}
                            fixedHeader={true}
                            className="approvalHierarchy-grid"
                         data-attribute="ApprovalListAssignment_Default_Grid" />
                        : null}
                </div> */}
            </Row>
            {showAlert && isEditList && showGrid &&
                <>
                    <Col xs={12} md={12} lg={12} className='mb-3 overall-save'>
                        <div className="confirmation-block mb-3">
                            {getAlertMessage()}
                        </div>
                    </Col>
                </>
            }
            {(isEditList && showGrid) ?
            <Row>
                <Col lg={12}>
                <div className="pull-right">
                    <PrimaryButton
                        text="Save"
                        className="pull-right"
                        onClick={onSaveClick}
                     data-attribute="ApprovalListAssignment_Default_Button_2" />
                </div>
                </Col>
            </Row>
                
                : null
            }
            {showValidatePopup ?
                            <PopupDialogbox
                                hideDialog={!Popupcontent.isDialogVisible}
                                onDismiss={hideDialog}
                                Popupcontent={Popupcontent}
                                popupOutlinebtnOnclick={Popupcontent?.popupOutlinebtnOnclick}
                                popupPrimarybtnOnclick={Popupcontent?.popupPrimarybtnOnclick}  data-attribute="ApprovalListAssignment_Default_PopupDilalogBox" />
                            :
                            <></>}
            <CompleteConfirmationPopup
                hideDialog={hideDialog}
                onDismiss={Popupcontent?.popupOutlinebtnOnclick}
                Popupcontent={Popupcontent}
                popupOutlinebtnOnclick={Popupcontent?.popupOutlinebtnOnclick}
                popupPrimarybtnOnclick={Popupcontent?.popupPrimarybtnOnclick}
            />
        </>

    )
}

export default ApprovalListAssignment
